import api from './api';

interface RelacionAgenteSitio {
  _id: string;
  agenteId: string;
  sitioId: { _id?: string; nombre?: string } | string;
  activo: boolean;
}

export const getSitiosByAgente = (agenteId: string) =>
  api.get<RelacionAgenteSitio[]>(`/relaciones/agentes/${agenteId}/sitios`);

export const asignarAgenteASitio = (agenteId: string, sitioId: string) =>
  api.post(`/relaciones/agentes/${agenteId}/sitios/${sitioId}`);

export const desasignarAgenteDeSitio = (agenteId: string, sitioId: string) =>
  api.delete(`/relaciones/agentes/${agenteId}/sitios/${sitioId}`);
